import React from 'react';
import clsx from 'clsx';
import { flexRender } from '@tanstack/react-table';

// LOCAL VARIABLES
import { ROW_HEIGHT, PLACEHOLDER } from '../../variables';

// STYLES
import styles from './tableSortedBody.module.scss';

export default function TableSortedBody({
  rows,
  rowHeight = ROW_HEIGHT,
  placeholder = PLACEHOLDER,
}) {
  return (
    <tbody>
      {rows.map(row => {
        return (
          <tr
            data-index={row.index}
            key={row.id}
            style={{
              minHeight: rowHeight,
            }}
            className={clsx(
              'tr table-row d-flex w-100',
              styles.row,
            )}
          >
            {row.getVisibleCells().map(cell => {
              const width = cell.column.getSize();
              const value = cell.getValue();
              const valueProp = ![undefined, null, ''].includes(value) ? value : placeholder;
              const { cellClassName, className, id } = cell.column.columnDef;

              return (
                <td
                  key={cell.id}
                  style={{
                    flexGrow: id !== 'actions' && width,
                    flexBasis: width,
                    width,
                  }}
                  className={clsx(
                    'td d-flex align-items-center table-col',
                    row.index % 2 === 0 && 'bg-gray-000',
                    styles.td,
                    className,
                    cellClassName
                  )}
                >
                  <div className={clsx(
                    'w-100 table-cell',
                    id === 'actions' && 'text-center',
                    styles.cell
                  )}>
                    {flexRender(
                      cell.column.columnDef.cell,
                      {
                        ...cell.getContext(),
                        column: {
                          ...cell.column,
                          ...cell.column.columnDef,
                        },
                        getValue: () => valueProp,
                        placeholder,
                        value: cell.getValue()
                      }
                    )}
                  </div>
                </td>
              )
            })}
          </tr>
        )
      })}
    </tbody>
  );
}
